import { call, put } from 'redux-saga/effects';
import { extractErrorFromResponse } from '../../assets/js/function-utils';
import ENDPOINTS from '../../consts/endpoints';
import api from '../../services/api';
import DADOS_SIM from './../../consts/consts';
import ENUM from './../../consts/enum';
import { Creators as listaBensCreators } from './../ducks/lista-bens';

const listaBemValues = DADOS_SIM.LISTA_BENS;

export function* sendLista(action) {
    const { objEnvio } = action.payload;
    try {
        let { data } = yield call(api.patch, ENDPOINTS.SEND_LISTA_BENS(objEnvio.codigoCotacao), objEnvio);
        if (data) {
            data.numeroPropostaAnterior = objEnvio.numprop;
            yield put(listaBensCreators.sendListaBensSuccess(data));
        }
    } catch (err) {
        yield put(listaBensCreators.sendListaBensFailure(extractErrorFromResponse(err)));
    }
}

export function* getMinMaxVigencia(action) {
    try {
        const { tipoCotacao, codigoCotacao } = action.payload;
        let data = null;
        if (tipoCotacao === ENUM.TIPO_COTACAO.NEG_ESPECIAL) {
            data = yield call(api.get, ENDPOINTS.GET_VIGENCIA_POR_COD_COTACAO(codigoCotacao));
        } else {
            data = yield call(api.get, ENDPOINTS.GET_VIGENCIA_POR_TIPO_COTACAO(tipoCotacao));
        }
        if (data) {
            if (data.data.status === 'OK') {
                const resultado = data.data.resultado;
                let tipoVigenciaOptions = [];

                if (resultado[listaBemValues.VIGENCIA_PADRAO]) {
                    tipoVigenciaOptions.push({ text: 'Padrão', value: 'Padrão', id: 0 });
                }
                if (resultado[listaBemValues.VIGENCIA_SELETIVA]) {
                    tipoVigenciaOptions.push({ text: 'Seletiva', value: 'Seletiva', id: 1 });
                }

                yield put(listaBensCreators.minimoMaximoVigenciaSuccess(resultado));
                yield put(listaBensCreators.setTipoVigenciaOptions(tipoVigenciaOptions));
            } else {
                yield put(listaBensCreators.minimoMaximoVigenciaFailure('Erro ao se comunicar com o servidor'));
            }
        }
    } catch (err) {
        yield put(listaBensCreators.minimoMaximoVigenciaFailure(extractErrorFromResponse(err)));
    }
}
